// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"213":"72ca1f98","298":"9fb92c5e","552":"b89e2946","575":"23abf56a","673":"6e27a158","824":"c6fb3358"}[chunkId] + ".css";
};